import { defineQuery } from "groq";

const GLOBAL_SETTINGS_QUERY = defineQuery(`*[_type == "globalSettings"]`);

const INITIATIVES_QUERY = defineQuery(`*[_type == "initiative"]`);

export { GLOBAL_SETTINGS_QUERY, INITIATIVES_QUERY };
